(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["painteasy-annual-club"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.pe-annual-native').forEach((annualClub) => {
const monthsSection = annualClub.querySelector('.months');
if (monthsSection) {
  const enableConceptImages = () => monthsSection.classList.add('concepts-ready');
  if ('IntersectionObserver' in window) {
    const conceptObserver = new IntersectionObserver((entries, observer) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        enableConceptImages();
        observer.disconnect();
      }
    }, { rootMargin: '500px 0px' });
    conceptObserver.observe(monthsSection);
  } else {
    enableConceptImages();
  }
}

(() => {
  const buttons = annualClub.querySelectorAll('[data-purchase-placeholder]');
  const toast = annualClub.querySelector('.toast');
  let timer;

  if (!buttons.length || !toast) return;

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      toast.textContent = '购买按钮已预留：创建 Shopify 年度会员商品后即可连接正式结账链接。年度会员不参与网红或达人折扣。';
      toast.classList.add('is-visible');
      clearTimeout(timer);
      timer = setTimeout(() => {
        toast.classList.remove('is-visible');
      }, 3200);
    });
  });
})();

const conceptCount = 36;
const conceptClasses = Array.from({ length: conceptCount }, (_, index) => `concept-${index + 1}`);
let conceptDeck = [];
let lastConcept = 0;

function refillConceptDeck() {
  conceptDeck = Array.from({ length: conceptCount }, (_, index) => index + 1);

  for (let index = conceptDeck.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(Math.random() * (index + 1));
    [conceptDeck[index], conceptDeck[swapIndex]] = [conceptDeck[swapIndex], conceptDeck[index]];
  }

  if (conceptDeck.length > 1 && conceptDeck[conceptDeck.length - 1] === lastConcept) {
    [conceptDeck[conceptDeck.length - 1], conceptDeck[conceptDeck.length - 2]] =
      [conceptDeck[conceptDeck.length - 2], conceptDeck[conceptDeck.length - 1]];
  }
}

function drawConcept() {
  if (!conceptDeck.length) refillConceptDeck();
  const nextConcept = conceptDeck.pop();
  lastConcept = nextConcept;
  return nextConcept;
}

function chooseNewConcept(card) {
  const next = drawConcept();
  card.classList.remove(...conceptClasses);
  card.classList.add(`concept-${next}`);
  card.dataset.concept = String(next);
}

annualClub.querySelectorAll('.month-card').forEach((card) => {
  card.addEventListener('click', () => {
    annualClub.querySelectorAll('.month-card.is-revealed').forEach((openCard) => {
      if (openCard !== card) {
        openCard.classList.remove('is-revealed');
        openCard.setAttribute('aria-pressed', 'false');
      }
    });

    if (card.classList.contains('is-revealed')) {
      card.classList.remove('is-revealed');
      card.setAttribute('aria-pressed', 'false');
      window.setTimeout(() => {
        chooseNewConcept(card);
        card.classList.add('is-revealed');
        card.setAttribute('aria-pressed', 'true');
      }, 220);
      return;
    }

    chooseNewConcept(card);
    card.classList.add('is-revealed');
    card.setAttribute('aria-pressed', 'true');
  });
});

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["painteasy-article"] && !Shopify.designMode) return;
  try {
    
function initPaintEasyArticle(root){if(root.dataset.peReady==='yes')return;root.dataset.peReady='yes';const body=root.querySelector('[data-pe-article-body] .pe-richtext');const headings=[...body.querySelectorAll('h2')];const toc=root.querySelector('[data-pe-toc]');const desktop=root.querySelector('[data-pe-toc-links]');const mobile=root.querySelector('[data-pe-mobile-links]');const mobileBox=root.querySelector('[data-pe-mobile-toc]');if(!headings.length){toc.hidden=true;mobileBox.hidden=true;return}const seen=new Set();headings.forEach((heading,index)=>{let id=heading.id||`pe-section-${index+1}`;while(seen.has(id)||document.getElementById(id)&&document.getElementById(id)!==heading)id=`pe-section-${index+1}-${seen.size+1}`;heading.id=id;seen.add(id);for(const nav of [desktop,mobile]){const link=document.createElement('a');link.href=`#${id}`;link.textContent=heading.textContent.trim();nav.append(link)}});mobile.addEventListener('click',event=>{if(event.target.closest('a'))mobileBox.open=false});const links=[...desktop.querySelectorAll('a')];const bar=root.querySelector('.pe-reading-progress');let ticking=false;function update(){const top=body.getBoundingClientRect().top+scrollY;const bottom=body.getBoundingClientRect().bottom+scrollY-innerHeight;const range=bottom-top;bar.style.width=`${range>0?Math.max(0,Math.min(100,(scrollY-top)/range*100)):0}%`;let current=headings[0].id;headings.forEach(h=>{if(h.getBoundingClientRect().top<innerHeight*.35)current=h.id});links.forEach(a=>{const active=a.hash==='#'+current;a.classList.toggle('is-active',active);if(active)a.setAttribute('aria-current','location');else a.removeAttribute('aria-current')});const sc=root.querySelector('.pe-sidebar');const act=desktop.querySelector('a.is-active');if(sc&&act&&getComputedStyle(sc).position==='sticky'){const sr=sc.getBoundingClientRect(),ar=act.getBoundingClientRect();if(ar.top<sr.top+8)sc.scrollTop+=ar.top-sr.top-8;else if(ar.bottom>sr.bottom-8)sc.scrollTop+=ar.bottom-sr.bottom+8}ticking=false}addEventListener('scroll',()=>{if(!ticking){requestAnimationFrame(update);ticking=true}},{passive:true});addEventListener('resize',update);update()}
document.querySelectorAll('[data-pe-article-section]').forEach(initPaintEasyArticle);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-pe-article-section]').forEach(initPaintEasyArticle));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["painteasy-featured-custom"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pe-judgeme-rating]').forEach(function (rating) {
    if (rating.dataset.loaded === 'true') return;
    rating.dataset.loaded = 'true';

    var source = rating.querySelector('[data-pe-judgeme-source] [data-average-rating][data-number-of-reviews]');
    if (!source) return;

    var average = Number.parseFloat(source.dataset.averageRating);
    var count = Number.parseInt(source.dataset.numberOfReviews, 10);
    if (!Number.isFinite(average) || !Number.isFinite(count) || count < 1) return;

    var percentage = Math.max(0, Math.min(100, average / 5 * 100));
    var stars = rating.querySelector('.pe-featured-custom__stars');
    var score = rating.querySelector('.pe-featured-custom__rating-score');
    var countText = rating.querySelector('.pe-featured-custom__rating-count');

    if (stars) stars.style.setProperty('--pe-rating-percent', percentage + '%');
    if (score) score.textContent = average.toFixed(1);
    if (countText) countText.textContent = '(' + count + (count === 1 ? ' review)' : ' reviews)');
    rating.setAttribute('aria-label', average.toFixed(1) + ' out of 5, ' + count + (count === 1 ? ' review' : ' reviews'));
    rating.hidden = false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["painteasy-pbn-guide"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pe-reveal]').forEach(function(section){var canvas=section.querySelector('canvas'),painted=section.querySelector('.pe-painted'),number=section.querySelector('.pe-progress b span'),done=section.querySelector('.pe-progress small em'),swatch=section.querySelector('.pe-progress i');if(!canvas||!painted)return;var image=new Image(),ctx,pixels,current=-1,palette=['#83c9ef','#1787bd','#f4eee2','#d8b99a','#73a64c','#164f36','#d98f68','#173c70'];image.crossOrigin='anonymous';image.src=painted.currentSrc||painted.src;function hue(r,g,b){r/=255;g/=255;b/=255;var max=Math.max(r,g,b),min=Math.min(r,g,b),d=max-min;if(!d)return-1;var h=max===r?((g-b)/d)%6:max===g?(b-r)/d+2:(r-g)/d+4;return(h*60+360)%360}function bucket(r,g,b){var max=Math.max(r,g,b),min=Math.min(r,g,b),sat=max?(max-min)/max:0,light=(max+min)/510;if(sat<.12)return light>.72?2:light>.48?3:7;var h=hue(r,g,b);if(h>=175&&h<205)return 0;if(h>=205&&h<255)return 1;if(h>=70&&h<150)return light>.48?4:5;if(h<45||h>=340)return 6;return light>.55?3:7}function paint(step){if(!pixels||step===current)return;current=step;var out=new ImageData(new Uint8ClampedArray(pixels.data),pixels.width,pixels.height);for(var i=0;i<out.data.length;i+=4){if(bucket(out.data[i],out.data[i+1],out.data[i+2])>=step)out.data[i+3]=0}ctx.clearRect(0,0,canvas.width,canvas.height);ctx.putImageData(out,0,0);painted.style.opacity=step>=8?1:0;var shown=Math.min(step,8);number.textContent=String(Math.min(shown+1,8)).padStart(2,'0');done.textContent=shown;swatch.style.background=palette[Math.min(shown,7)]}image.onload=function(){canvas.width=image.naturalWidth;canvas.height=image.naturalHeight;ctx=canvas.getContext('2d',{willReadFrequently:true});ctx.drawImage(image,0,0);pixels=ctx.getImageData(0,0,canvas.width,canvas.height);paint(0)};window.addEventListener('scroll',function(){var rect=section.getBoundingClientRect(),range=section.offsetHeight-window.innerHeight,q=Math.max(0,Math.min(1,-rect.top/range));paint(Math.min(8,Math.floor(q*9)))},{passive:true})});
;
;(function(){var steps=document.querySelector('.pe-steps');if(!steps)return;steps.classList.add('pe-colors');var arts=[].slice.call(steps.querySelectorAll('article'));var cols=['#a8cdf5','#1765e5','#ff786a','#ffd44a'],light=[1,0,1,1];function upd(){var vh=window.innerHeight;arts.forEach(function(a,i){var on=a.getBoundingClientRect().top<vh*0.55;if(on&&!a.classList.contains('pe-active')){a.style.backgroundColor=cols[i];a.classList.add('pe-active');a.classList.toggle('pe-on-light',!!light[i]);a.classList.toggle('pe-on-dark',!light[i])}else if(!on&&a.classList.contains('pe-active')){a.style.backgroundColor='';a.classList.remove('pe-active','pe-on-light','pe-on-dark')}})}window.addEventListener('scroll',upd,{passive:true});window.addEventListener('resize',upd);upd()})();
;(function(){var g=document.querySelector('.pe-guide'),j=document.querySelector('.pe-jump');if(!g||!j)return;function fit(){var e=document.querySelector('header.pe-native-header')||document.querySelector('header');var hh=(e&&getComputedStyle(e).position!=='static')?e.offsetHeight:0;g.style.setProperty('--pe-head',hh+'px')}fit();window.addEventListener('resize',fit)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["painteasy-review-strip"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.pe-review-strip').forEach(function (section) {
    var track = section.querySelector('[data-pe-review-track]');
    var previous = section.querySelector('[data-pe-review-prev]');
    var next = section.querySelector('[data-pe-review-next]');
    if (!track || !previous || !next) return;

    var update = function () {
      previous.disabled = track.scrollLeft < 10;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 10;
    };

    previous.addEventListener('click', function () {
      track.scrollBy({ left: -track.clientWidth * 0.82, behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      track.scrollBy({ left: track.clientWidth * 0.82, behavior: 'smooth' });
    });

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pe-home-decor-page"] && !Shopify.designMode) return;
  try {
    
  const initHomeDecor = (root) => {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const scene = root.querySelector('[data-room]');
    const image = root.querySelector('.pe-home-decor__wall-art img');
    const title = root.querySelector('[data-art-title]');
    const link = root.querySelector('[data-art-link]');
    root.querySelectorAll('[data-room-button]').forEach((button) => {
      button.addEventListener('click', () => {
        scene.dataset.room = button.dataset.roomButton;
        root.querySelectorAll('[data-scene-image]').forEach((item) => item.classList.toggle('is-active', item.dataset.sceneImage === button.dataset.roomButton));
        root.querySelectorAll('[data-room-button]').forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-pressed', String(selected));
        });
      });
    });
    root.querySelectorAll('[data-frame-shape-button]').forEach((button) => {
      button.addEventListener('click', () => {
        scene.dataset.frameShape = button.dataset.frameShapeButton;
        root.querySelectorAll('[data-frame-shape-button]').forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-pressed', String(selected));
        });
      });
    });
    const artButtons = Array.from(root.querySelectorAll('[data-art-button]'));
    const selectArt = (button) => {
        if (image) {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = button.dataset.image;
          image.alt = button.dataset.title;
          image.animate([{ opacity: .25 }, { opacity: 1 }], { duration: 260, easing: 'ease-out' });
        }
        if (title) title.textContent = button.dataset.title;
        if (link) link.href = button.dataset.url;
        artButtons.forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-pressed', String(selected));
        });
    };
    artButtons.forEach((button) => button.addEventListener('click', () => selectArt(button)));
    const artGrid = root.querySelector('.pe-home-decor__art-buttons');
    const refreshArt = root.querySelector('[data-art-refresh]');
    const orderedArt = [...artButtons].sort((a, b) => Number(a.dataset.artRank) - Number(b.dataset.artRank) || Number(a.dataset.artGroup) - Number(b.dataset.artGroup));
    orderedArt.forEach((button) => artGrid?.appendChild(button));
    const batchSize = 8;
    let batchIndex = 0;
    const batchCount = Math.max(1, Math.ceil(orderedArt.length / batchSize));
    const showArtBatch = () => {
      const start = batchIndex * batchSize;
      orderedArt.forEach((button, index) => { button.hidden = index < start || index >= start + batchSize; });
    };
    showArtBatch();
    if (refreshArt) refreshArt.addEventListener('click', () => {
      batchIndex = (batchIndex + 1) % batchCount;
      showArtBatch();
      const firstVisible = orderedArt[batchIndex * batchSize];
      if (firstVisible) selectArt(firstVisible);
    });
    const activateColor = (button, selector, variable, opacityVariable) => {
      scene.style.setProperty(variable, button.dataset.wallColor || button.dataset.furnitureColor);
      scene.style.setProperty(opacityVariable, button.dataset.opacity || '0.58');
      root.querySelectorAll(selector).forEach((item) => { const selected = item === button; item.classList.toggle('is-active', selected); item.setAttribute('aria-pressed', String(selected)); });
    };
    root.querySelectorAll('[data-wall-color]').forEach((button) => button.addEventListener('click', () => activateColor(button, '[data-wall-color]', '--studio-wall-tint', '--studio-wall-opacity')));
    root.querySelectorAll('[data-furniture-color]').forEach((button) => button.addEventListener('click', () => activateColor(button, '[data-furniture-color]', '--studio-furniture-tint', '--studio-furniture-opacity')));
    root.querySelectorAll('[data-frame-color]').forEach((button) => button.addEventListener('click', () => {
      scene.style.setProperty('--studio-frame-color', button.dataset.frameColor);
      root.querySelectorAll('[data-frame-color]').forEach((item) => { const selected = item === button; item.classList.toggle('is-active', selected); item.setAttribute('aria-pressed', String(selected)); });
    }));
    const wallPicker = root.querySelector('[data-wall-picker]');
    const furniturePicker = root.querySelector('[data-furniture-picker]');
    const framePicker = root.querySelector('[data-frame-picker]');
    if (wallPicker) wallPicker.addEventListener('input', () => { scene.style.setProperty('--studio-wall-tint', wallPicker.value); scene.style.setProperty('--studio-wall-opacity', '0.42'); root.querySelectorAll('[data-wall-color]').forEach((item) => { item.classList.remove('is-active'); item.setAttribute('aria-pressed', 'false'); }); });
    if (furniturePicker) furniturePicker.addEventListener('input', () => { scene.style.setProperty('--studio-furniture-tint', furniturePicker.value); scene.style.setProperty('--studio-furniture-opacity', '0.62'); root.querySelectorAll('[data-furniture-color]').forEach((item) => { item.classList.remove('is-active'); item.setAttribute('aria-pressed', 'false'); }); });
    if (framePicker) framePicker.addEventListener('input', () => { scene.style.setProperty('--studio-frame-color', framePicker.value); root.querySelectorAll('[data-frame-color]').forEach((item) => { item.classList.remove('is-active'); item.setAttribute('aria-pressed', 'false'); }); });
  };
  document.querySelectorAll('[data-pe-home-decor]').forEach(initHomeDecor);
  document.addEventListener('shopify:section:load', (event) => initHomeDecor(event.target.querySelector('[data-pe-home-decor]')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["today-on-canvas"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', async function (event) {
    const button = event.target.closest('.toc-vote__share');
    if (!button) return;

    const shareData = {
      title: button.dataset.shareTitle,
      text: button.dataset.shareText,
      url: window.location.href.split('#')[0] + '#toc-vote'
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (error) {
        return;
      }
    } else if (navigator.clipboard) {
      await navigator.clipboard.writeText(shareData.url);
      const originalText = button.textContent;
      button.textContent = 'Link copied';
      window.setTimeout(function () {
        button.textContent = originalText;
      }, 1800);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
